@let currentTypesValue = currentTypes();
@let categoriesValue = selectedParentCategories();

<div class="p-2">
    @for (type of currentTypesValue; track type.number) {
        <app-camp-type-section [campType]="type" [selectedParentCategories]="categoriesValue"> </app-camp-type-section>
    }
</div>
